import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Section = styled.section`
  margin: 6rem 0 4rem;
  padding: 4rem 2.5rem;
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.primary} 0%, ${({ theme }) => theme.colors.secondary} 100%);
  border-radius: 2rem;
  box-shadow: ${({ theme }) => theme.shadows.xl};
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
    pointer-events: none;
  }

  @media (max-width: 768px) {
    padding: 3rem 1.5rem;
    margin: 4rem 0 2rem;
  }
`;

const Content = styled.div`
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
`;

const Title = styled.h2`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: clamp(2rem, 4vw, 3rem);
  color: white;
  margin: 0 0 1rem;
  font-weight: 700;
  line-height: 1.2;
`;

const Description = styled.p`
  font-size: clamp(1rem, 2vw, 1.25rem);
  color: rgba(255, 255, 255, 0.95);
  margin: 0 0 2.5rem;
  line-height: 1.6;
`;

const CTAButton = styled(Link)`
  display: inline-block;
  padding: 1.25rem 3rem;
  background: white;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 700;
  font-size: 1.1rem;
  font-family: ${({ theme }) => theme.fonts.heading};
  border-radius: 999px;
  text-decoration: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  transform: translateY(0);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
    background: #f8f9fa;
  }

  &:active {
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    padding: 1rem 2rem;
    font-size: 1rem;
  }
`;

const PortalButton = styled(Link)`
  display: inline-block;
  padding: 1.25rem 2.4rem;
  border: 1.5px solid rgba(255, 255, 255, 0.8);
  color: #fff;
  font-weight: 700;
  font-size: 1.05rem;
  font-family: ${({ theme }) => theme.fonts.heading};
  border-radius: 999px;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    padding: 1rem 1.5rem;
    font-size: 0.95rem;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.9rem;
  flex-wrap: wrap;
`;

const JoinTodayBanner = () => (
  <Section>
    <Content>
      <Title>지금 시작하세요</Title>
      <Description>
        에이스코딩학원과 함께 여러분의 코딩 여정을 시작하세요.<br />
        전문 상담을 통해 최적의 학습 경로를 제안해드립니다.
      </Description>
      <ButtonGroup>
        <CTAButton to="/join">상담 문의하기</CTAButton>
        <PortalButton to="/portal/login">에이스코딩학원 포털 바로가기</PortalButton>
      </ButtonGroup>
    </Content>
  </Section>
);

export default JoinTodayBanner;

